import { createListenerMiddleware } from '@reduxjs/toolkit';

import {
  changeEndDate,
  changeStartDate,
  changeSelectedFiscalYear,
} from 'slices/budget-comparison-slice';

import getMaxAvailableEndDate from 'utils/fiscal-years/getMaxAvailableEndDate';
import isCurrentFiscalYear from 'utils/fiscal-years/isCurrentFiscalYear';
import { toDate } from 'utils';

const budgetComparisonListenerMiddleware = createListenerMiddleware();

budgetComparisonListenerMiddleware.startListening({
  actionCreator: changeSelectedFiscalYear,
  effect: (action, listenerApi) => {
    const fiscalYear = action.payload;

    const startDate = fiscalYear?.StartDate
      ? toDate(fiscalYear.StartDate)
      : null;
    const endDate = fiscalYear?.EndDate
      ? isCurrentFiscalYear(fiscalYear)
        ? getMaxAvailableEndDate(toDate(fiscalYear.EndDate) as Date)
        : new Date(fiscalYear.EndDate)
      : null;

    listenerApi.dispatch(changeStartDate(startDate));
    listenerApi.dispatch(changeEndDate(endDate));
  },
});

export default budgetComparisonListenerMiddleware.middleware;
